import * as STD from '@emersya/mpa-std-lib';

import * as BasketNS     from '@emersya/mpa-basket-lib';
import CM                from '@emersya/mpa-components-manager-lib';
import { Field, Text }   from '@emersya/mpa-components-lib';

export interface IPlannerDimensionsEditorComponentConfiguration extends CM.DOMComponent.IConfiguration {
	readonly width : {
		readonly min : number;
		readonly max : number;
		readonly default : number;
	};
	readonly height : {
		readonly min : number;
		readonly max : number;
		readonly default : number;
	};
	readonly depth : {
		readonly min : number;
		readonly max : number;
		readonly default : number;
	};
	readonly increment : number;
};

export class PlannerDimensionsEditorComponent extends CM.DOMComponent<
	HTMLDivElement,
	PlannerDimensionsEditorComponent,
	IPlannerDimensionsEditorComponentConfiguration
>
{
	static override initialize() {
		super.initialize();
	};

	component_DOM : HTMLDivElement;

	async onDimensionUpdated(event : STD.events.Event<any, CM.Component<any, any>>) {
		await app.sequential(async () => {
			if (!app.basket || !app.basket.basket.currentProduct) {
				return;
			}
			await app.basket.basket.usePartReference(
				app.basket.basket.currentProduct.id,
				[ 'dimensions', event.target.component_parent.id ],
				event.details.newValue
			);
		});
	};

	async reset() {
		const module = app.modules.used.find(x => x.id === 'viewer-planner-dimensionsEditor');
		if (!module) {
			this.component_throwLibraryError('');
		}
		await (<Field.Component> this.component_find('@:width')).updateValue(module.configuration[ 'width-default' ]);
		await (<Field.Component> this.component_find('@:depth')).updateValue(module.configuration[ 'depth-default' ]);
		await (<Field.Component> this.component_find('@:height')).updateValue(module.configuration[ 'height-default' ]);
	};

	override async component_initialize() {
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		for (const product of app.basket.basket.products) {
			const part = product.createPart({
				id :        'dimensions',
				title :     'Dimensions',
				reference : null,
				metaData :  null,
				parts :     [
					{
						id :        'width',
						title :     'Width',
						reference : BasketNS.Reference.deserialize({ value : '0' }),
						options :   [],
						metaData :  null,
						parts :     []
					}, {
						id :        'depth',
						title :     'Depth',
						reference : BasketNS.Reference.deserialize({ value : '0' }),
						options :   [],
						metaData :  null,
						parts :     []
					}, {
						id :        'height',
						title :     'Height',
						reference : BasketNS.Reference.deserialize({ value : '0' }),
						options :   [],
						metaData :  null,
						parts :     []
					}
				],
				options :   []
			});
			await part.initialize();
		}
		(<Text.Component> this.component_find('@:width:header.unit')).update('m');
		(<Text.Component> this.component_find('@:depth:header.unit')).update('m');
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IPlannerDimensionsEditorComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});
	};
};
export namespace NS {
	export const Component = PlannerDimensionsEditorComponent;
	export type Component = PlannerDimensionsEditorComponent;
	export type Configuration = IPlannerDimensionsEditorComponentConfiguration;
}
import manifestXMLSource from './PlannerDimensionsEditor.xml';
import './PlannerDimensionsEditor.scss';

CM.declare({
	id :       'viewer-planner-dimensionsEditor',
	type :     PlannerDimensionsEditorComponent,
	manifest : manifestXMLSource
});
